<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="devicesCampaigns"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50]
      }"
      :items-per-page="50"
      hide-default-footer
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item,index) in items" :key="index">
            <td class="text-left">{{item.name}}</td>
            <td class="text-center">{{item.published ? 'Yes' : 'No'}}</td>
            <!-- <td class="text-left">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    outlined
                    color="primary"
                    class="mr-1 mt-1"
                    dark
                    fab
                    x-small
                    v-on="on"
                    @click="openPublishCampaignWarning(item)"
                  >
                    <v-icon small class>publish</v-icon>
                  </v-btn>
                </template>
                <span>Publish</span>
              </v-tooltip>
            </td> -->
          </tr>
        </tbody>
      </template>
    </v-data-table>

    <v-dialog v-model=" publishCampaignWarning" persistent scrollable :width="300">
      <v-card>
        <v-card-title class="primary text-white">Publish campaign?</v-card-title>
        <v-card-text class="text-center">
          <v-icon size="60" color="warning" class="mt-7 mb-3">warning</v-icon>
          <div>Are you sure you want to publish this campaign?</div>
          <div class="mt-4">
            <v-btn text color="error" @click="closePublishCampaignWarning">No</v-btn>
            <v-btn text color="success" @click="confirmPublishCampaign">Yes</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Currently playing',
          value: 'published',
          align: 'center'
        }
        // {
        //   text: 'Publish'
        // }
      ],
      publishCampaignWarning: false,
      campaign: ''
    }
  },
  computed: {
    ...mapGetters({
      devicesCampaigns: 'signage/devicesCampaigns'
    })
  },
  methods: {
    openPublishCampaignWarning (campaign) {
      this.campaign = campaign
      this.publishCampaignWarning = true
    },
    closePublishCampaignWarning () {
      this.publishCampaignWarning = false
    },
    async confirmPublishCampaign () {
      let campaign = this.campaign
      this.spinner(true)
      this.publishCampaignWarning = false

      setTimeout(async () => {
        const value = {
          deviceId: campaign.device_id,
          campaignId: campaign.campaign.id
        }
        try {
          await this.publishDeviceCampaign(value)
          this.snackbar({ text: 'Campaign published.' })
        } catch (e) {
          this.snackbar({ text: 'Publish failed.' })
        }
        try {
          await this.fetchDeviceCampaigns(campaign.device_id)
        } catch (e) {
          this.snackbar({ text: e.response.data.msg })
        }
        this.spinner(false)
      }, 500)
    },
    ...mapActions({
      publishDeviceCampaign: 'signage/PublishDeviceCampaign',
      fetchDeviceCampaigns: 'signage/GetCampaignsForDevice'
    })
  }
}
</script>

<style>
</style>
